import { render, staticRenderFns } from "./mouldList.vue?vue&type=template&id=e89c2c5c&scoped=true&"
import script from "./mouldList.vue?vue&type=script&lang=js&"
export * from "./mouldList.vue?vue&type=script&lang=js&"
import style0 from "./mouldList.vue?vue&type=style&index=0&id=e89c2c5c&scoped=true&lang=css&"
import style1 from "./mouldList.vue?vue&type=style&index=1&id=e89c2c5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89c2c5c",
  null
  
)

export default component.exports